var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPotionPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_8519)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.196 15.2557C26.2422 13.9231 25.0836 12.9757 24.0987 12.6318C19.3931 10.9801 17.376 12.4214 16.7491 11.6718C16.5684 11.4816 16.4514 11.2399 16.4146 10.9801C16.3777 10.7204 16.4228 10.4556 16.5435 10.2227L14.0184 11.8602L11.2799 13.1112C11.5418 13.1342 11.79 13.2386 11.9897 13.4096C12.1894 13.5806 12.3306 13.8098 12.3936 14.0651C12.6778 15.0028 10.3789 15.9224 9.25302 20.7904C8.95683 22.0681 9.31569 24.0936 10.3627 25.9743C12.3309 29.4928 16.695 32.5454 23.7082 29.501C30.7457 24.7584 29.665 18.7083 27.196 15.2557ZM10.6629 24.073C8.99671 18.4969 12.9758 15.2919 13.0928 14.4186C13.2099 13.5452 12.5251 12.6786 12.5251 12.6786L15.2381 11.19C15.4471 11.7823 15.8578 12.2823 16.3982 12.6025C17.1933 12.954 22.0223 11.2969 25.8487 15.7132C29.675 20.1296 27.2045 25.1235 22.7194 28.0236C17.8732 30.2731 12.3354 29.6601 10.6566 24.0621L10.6629 24.073Z",
    fill: "url(#paint0_linear_490_8519)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36697 10.798C7.32063 11.2811 8.74625 13.0693 9.36198 13.4128C10.771 14.1719 17.2507 10.1445 17.5452 9.09105C17.7607 8.28715 16.7046 6.004 16.3786 5.75049C16.0527 5.49698 7.36697 10.798 7.36697 10.798Z",
    fill: "url(#paint1_linear_490_8519)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36671 10.7981C7.60186 11.735 17.0295 7.2482 16.3747 5.75264C15.72 4.25708 6.8528 8.73099 7.36671 10.7981Z",
    fill: "#EBC3D3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74881 9.94673C8.9081 10.5925 15.2472 7.33066 14.8016 6.30654C14.3559 5.28243 8.41295 8.52431 8.74881 9.94673Z",
    fill: "#9A376D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92178 10.8176C7.87087 11.0991 9.07013 12.2852 10.0188 12.8102C10.9675 13.3352 16.8275 10.0926 16.701 8.61242C16.5745 7.13224 16.1217 7.55866 13.8421 8.70492C12.2388 9.49188 10.5966 10.197 8.92178 10.8176Z",
    fill: "#9A376D"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M9.75282 10.5418C9.38776 10.6409 11.0359 11.8057 12.5915 11.7763C14.1472 11.747 15.6214 9.32322 15.3199 8.00232C15.3199 8.00232 11.782 9.70999 9.75282 10.5418Z",
    fill: "url(#paint2_linear_490_8519)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6323 8.40849C10.933 9.55947 14.0414 8.25987 14.8847 7.59343C15.7279 6.92699 16.5295 5.91088 16.2884 5.75397C16.1373 5.65193 14.8175 6.78766 13.9987 7.45452C13.5714 7.81098 13.1142 8.13014 12.6323 8.40849Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0618 7.81691C16.7264 7.9086 16.5291 9.2651 16.341 9.86397C16.1528 10.4628 17.311 9.45922 17.4263 8.77621C17.5417 8.09319 17.2357 7.76504 17.0618 7.81691Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47077 10.4566C7.36697 10.798 7.7524 10.9444 8.24558 10.815C8.73876 10.6856 8.03405 10.1459 7.84235 10.1838C7.69549 10.2383 7.5668 10.3328 7.47077 10.4566Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5262 13.0757C10.7568 13.3404 9.60639 11.6504 9.69923 11.1891C9.79206 10.7278 13.7232 11.5257 13.5282 11.9781C13.3331 12.4305 11.5262 13.0757 11.5262 13.0757Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82061 11.2982C7.84689 11.5791 8.68608 12.6963 9.16388 13.0951C9.29433 13.2205 9.45599 13.3087 9.63204 13.3504C9.80808 13.3922 9.99211 13.386 10.165 13.3326C10.317 13.2933 9.04629 12.3282 8.51943 11.8024C7.80191 11.0808 7.80191 11.0808 7.82061 11.2982Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6802 9.77735C7.35524 10.4503 7.2674 10.7438 9.14717 9.02262C11.0269 7.30148 13.676 6.09727 14.3383 6.0255C15.0007 5.95373 15.1409 6.53289 16.0208 5.78703C16.9008 5.04118 13.9815 5.5083 11.1725 7.09124C8.36353 8.67417 7.6802 9.77735 7.6802 9.77735Z",
    fill: "#9A376D"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33713 9.95652C8.05708 8.21366 6.68675 6.53894 5.23178 4.93922C5.23178 4.93922 9.88622 -0.0972819 14.2711 1.41921C14.2711 1.41921 13.8685 4.56394 14.8241 6.77403C14.8241 6.77403 13.085 8.57901 9.33713 9.95652Z",
    fill: "url(#paint3_linear_490_8519)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2408 1.66987C13.6611 4.02861 4.72639 5.87188 5.1995 4.74931C5.67262 3.62673 7.03112 2.63369 8.56334 1.89953C8.81359 1.91678 9.06472 1.88248 9.30118 1.79875C9.47638 1.68825 9.63278 1.55043 9.76444 1.39052L9.93205 1.32773C9.93205 1.32773 10.2678 2.02698 10.6302 1.09938C12.7177 0.486316 14.5297 0.522563 14.2408 1.66987Z",
    fill: "#FF7A00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1451 9.64063C10.1451 9.64063 7.3139 5.64479 7.40932 4.94414C7.50475 4.24348 9.64012 2.20003 11.6182 1.48995C13.5964 0.779877 14.2696 1.51725 14.2696 1.51725C13.7578 1.33447 13.2106 1.27302 12.671 1.33776C12.1314 1.40251 11.6142 1.59167 11.1602 1.89034C9.51137 2.91022 7.76382 4.22982 7.91294 5.05139C8.06207 5.87295 10.6244 9.43672 10.6244 9.43672L10.1451 9.64063Z",
    fill: "#B10053"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4527 9.05554C11.4527 9.05554 9.4048 5.55883 9.53287 4.46074C9.66093 3.36264 14.0739 2.05255 14.0739 2.05255C14.0739 2.05255 10.1923 3.49271 9.80101 4.37873C9.40975 5.26475 12.0379 8.73228 12.0379 8.73228L11.4527 9.05554Z",
    fill: "#B10053"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0083 8.14303C13.0083 8.14303 11.6016 6.16905 12.4652 4.68028C13.3288 3.19152 14.2306 4.09786 14.2306 4.09786L14.3117 4.85195C14.3117 4.85195 13.4081 3.91747 12.6697 4.9505C11.9314 5.98354 13.2382 8.02 13.2382 8.02L13.0083 8.14303Z",
    fill: "#B10053"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05981 7.12202C9.05981 7.12202 7.59956 5.63526 7.42386 4.93582C7.24817 4.23637 10.5544 2.27895 10.5544 2.27895C10.5544 2.27895 8.18926 3.88233 7.92868 4.84337C7.73143 5.51059 9.05981 7.12202 9.05981 7.12202Z",
    fill: "#97001A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3111 6.10339C10.3111 6.10339 9.32846 4.72921 9.62546 4.21797C9.92246 3.70673 11.4456 3.16708 11.4456 3.16708C11.4456 3.16708 10.0078 3.77882 9.79034 4.36061C9.5729 4.94241 10.3111 6.10339 10.3111 6.10339Z",
    fill: "#97001A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43251 4.52232C5.08041 4.83725 6.71038 4.97859 7.06662 4.88941C7.42285 4.80023 8.14022 3.73079 8.65152 3.33851C9.16282 2.94623 5.91957 4.07124 5.43251 4.52232Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95561 4.73053C8.43728 4.70303 8.91481 4.62577 9.38058 4.49999C9.50518 4.37951 9.82796 3.92134 10.0203 3.67439C10.2126 3.42743 8.88223 3.35097 7.95561 4.73053Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 4.31211C10.9364 3.98966 11.8513 3.60893 12.7398 3.17214C13.1257 2.99039 13.4735 2.73687 13.7647 2.42512C13.7647 2.42512 11.4012 2.77038 10.0003 4.31211Z",
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7642 4.61829C9.90769 4.54076 10.0356 4.4373 10.1414 4.31316C10.1652 4.26433 10.176 4.21016 10.1728 4.15591C10.1695 4.10166 10.1523 4.04917 10.1228 4.00354C9.93194 4.15758 9.80433 4.37635 9.7642 4.61829Z",
    fill: "#FFA457"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92216 5.21105C7.92216 5.21105 8.23185 4.97401 8.1706 4.80066C8.10934 4.62731 8.01034 4.64078 8.01034 4.64078C8.01034 4.64078 7.84513 4.77499 7.92216 5.21105Z",
    fill: "#FFA457"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1139 8.58657C12.1139 8.58657 10.295 5.8313 10.129 5.19908C9.96296 4.56685 11.5805 3.90478 12.5884 3.43938C13.5962 2.97398 12.4245 3.53396 12.1854 4.97771C11.9462 6.42147 12.8193 7.88321 12.7671 8.11233C12.715 8.34145 12.1139 8.58657 12.1139 8.58657Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35817 5.06608C8.22573 5.18138 9.15221 7.28211 10.2247 8.4588C11.2973 9.6355 10.9627 8.39191 10.8691 8.08679C10.7754 7.78167 9.51358 5.30182 9.47525 5.00845C9.43693 4.71508 8.35817 5.06608 8.35817 5.06608Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28482 5.04019C7.20706 4.9055 5.73521 5.26503 5.77863 5.29821C5.82205 5.33138 8.68771 8.86564 9.11061 9.22821C9.53351 9.59078 8.41026 7.44348 7.28482 5.04019Z",
    fill: "#D42F55"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7329 7.01066C12.7329 7.01066 12.4172 5.89212 12.6021 5.27085C12.6353 5.10763 12.7065 4.95453 12.8099 4.82398C12.9133 4.69343 13.0461 4.58911 13.1973 4.51948C13.1973 4.51948 12.7366 4.5622 12.4996 5.32031C12.3897 5.89409 12.4717 6.4881 12.7329 7.01066Z",
    fill: "#FF6500"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2166 7.57069C11.2166 7.57069 10.2239 5.71688 10.0353 5.27245C9.84665 4.82803 9.76438 4.61827 9.76438 4.61827C9.76438 4.61827 9.68034 5.41428 11.2166 7.57069Z",
    fill: "#FF6500"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93242 1.32748L10.3952 1.50687C10.3952 1.50687 10.1582 1.79417 9.93242 1.32748Z",
    fill: "#E23100"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56372 1.89923C8.99908 1.82823 9.41101 1.65366 9.76482 1.39022C9.64644 1.5934 9.46545 1.75278 9.24895 1.84454C9.03244 1.93629 8.79204 1.95548 8.56372 1.89923Z",
    fill: "#E23100"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8721 1.35848C14.0056 1.47394 14.122 1.60771 14.218 1.7558C14.2237 1.87641 14.2222 1.99725 14.2134 2.11767C14.2134 2.11767 14.2755 1.55273 14.2696 1.5173C14.2637 1.48187 13.8721 1.35848 13.8721 1.35848Z",
    fill: "#97001A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85449 9.28882C8.85449 9.28882 9.51582 9.92145 12.09 8.53717C14.6642 7.15288 14.6394 6.26923 14.6394 6.26923L14.8314 6.76996C14.8314 6.76996 13.0884 8.63543 9.33812 9.94153L8.85449 9.28882Z",
    fill: "#D42F55"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.7236 28.0309C17.8753 30.2767 12.3354 29.6601 10.6587 24.0657C10.2688 22.8291 10.1537 21.5223 10.3215 20.2366C10.7732 17.0004 12.9941 15.0629 13.0877 14.4264C13.2147 13.5619 12.52 12.6864 12.52 12.6864L15.2329 11.1978C15.442 11.7901 15.8526 12.2901 16.393 12.6103C17.0064 12.8823 20.0269 11.9684 23.1326 13.573C24.167 14.1143 25.0867 14.8509 25.841 15.7419C29.6772 20.1332 27.2259 25.1354 22.7236 28.0309Z",
    fill: "url(#paint4_radial_490_8519)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7236 28.0309C17.8753 30.2767 12.3354 29.6601 10.6587 24.0657C10.2689 22.8291 10.1538 21.5223 10.3216 20.2366L18.049 18.9253L23.1285 13.5657C24.1628 14.107 25.0826 14.8436 25.8369 15.7346C29.6772 20.1332 27.226 25.1353 22.7236 28.0309Z",
    fill: "url(#paint5_linear_490_8519)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2849 22.1071C10.335 20.2434 15.278 20.8601 19.8486 22.9926C24.4192 25.125 24.4956 21.5667 24.4121 18.7318C24.3286 15.8968 26.8031 21.0403 26.1683 23.4551C25.5336 25.8698 28.3779 21.9269 27.491 18.6336C26.604 15.3403 23.1378 13.5653 23.1378 13.5653C23.1378 13.5653 24.9315 15.2429 24.0028 16.4927C23.074 17.7424 16.8427 19.6946 14.1645 19.974C11.4863 20.2534 10.335 20.2434 10.335 20.2434C10.2499 20.8609 10.2331 21.4859 10.2849 22.1071Z",
    fill: "#9A7AFF"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6417 19.7992C8.57673 20.7875 15.3411 20.8768 21.0683 18.4633C26.7954 16.0499 23.6204 13.6359 22.4768 13.2526C21.3333 12.8692 18.2996 15.6351 15.6397 17.3165C14.0418 18.2746 12.3706 19.1048 10.6417 19.7992Z",
    fill: "url(#paint6_linear_490_8519)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4788 28.6312C9.73505 24.6183 20.5499 26.6453 23.3458 25.7543C26.1417 24.8633 26.9058 23.631 26.9058 23.631C26.9058 23.631 24.9659 27.2993 21.4843 28.5328C18.0027 29.7662 14.4788 28.6312 14.4788 28.6312Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2198 25.5086C11.2198 25.5086 15.367 31.8511 22.5488 27.9134C29.7307 23.9757 26.8449 17.0942 26.8449 17.0942C26.8449 17.0942 30.7535 23.822 22.7976 28.1678C14.8418 32.5135 11.2198 25.5086 11.2198 25.5086Z",
    fill: "#9A3792"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6201 28.4746C23.7914 28.6618 26.5857 25.6748 27.6537 23.1361C28.7217 20.5974 29.3823 25.6426 24.6201 28.4746Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6582 23.6193C10.2694 25.174 10.1165 20.6803 10.2071 19.3659C10.2977 18.0516 8.66885 21.0986 9.6582 23.6193Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3497 18.798C10.0942 18.9019 10.2866 17.9657 10.5056 17.8489C10.7246 17.7322 10.6693 18.6621 10.3497 18.798Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7922 12.6386C22.4534 12.8925 24.5222 14.0376 25.6392 15.1401C26.7562 16.2426 26.6322 14.96 26.0156 14.0685C25.399 13.1771 23.3872 12.198 22.7922 12.6386Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2054 14.7562C13.0843 13.8993 12.9572 15.3269 15.3159 14.7465C17.6747 14.1662 17.3667 12.6743 16.7835 11.8995C16.6135 11.6582 16.5018 11.3808 16.4572 11.089C16.4126 10.7973 16.4362 10.4992 16.5263 10.2181C14.9695 11.504 13.1836 12.4841 11.2627 13.1066C11.2627 13.1066 12.5691 13.5366 12.2054 14.7562Z",
    fill: "#9A376D"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M15.6238 28.5382C15.6238 28.5382 11.4723 28.0228 10.6987 22.7904C10.1335 18.9279 12.0124 16.6588 12.0124 16.6588C12.0124 16.6588 12.9289 16.0519 15.0356 19.6167C17.1422 23.1814 17.3017 27.72 15.6238 28.5382Z",
    fill: "url(#paint7_linear_490_8519)"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3997 20.4734C15.0851 20.4025 17.7439 19.9216 20.284 19.0473C24.7634 17.558 24.41 15.4662 24.41 15.4662C24.41 15.4662 23.9083 16.9597 20.4317 18.496C16.9552 20.0324 12.3997 20.4734 12.3997 20.4734Z",
    fill: "#D181FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.547 19.5696C18.1741 19.5373 19.8396 18.6389 20.7943 18.4177C21.749 18.1966 21.3054 18.6808 20.9535 18.8112C20.6016 18.9415 18.547 19.5696 18.547 19.5696Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7348 20.3145C13.9171 20.4031 19.2979 22.6358 21.7753 23.5304C24.2528 24.425 24.0088 20.6731 24.0635 18.9184C24.071 18.0111 24.172 17.107 24.3649 16.2204C23.3146 17.3723 22.0405 18.2978 20.6204 18.9405C18.4236 19.8351 14.7348 20.3145 14.7348 20.3145Z",
    fill: "#DE0098"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7055 29.522C16.6923 32.5663 12.3282 29.5137 10.3599 25.9953C10.526 26.2828 14.7603 33.4488 23.3637 29.3504C32.1467 25.1678 27.1958 15.2558 27.1958 15.2558C29.6648 18.7084 30.7455 24.7585 23.7055 29.522Z",
    fill: "#9A376D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8906 20.7102C11.5304 20.6405 14.1138 24.0222 16.5446 25.5505C18.9753 27.0788 17.1239 24.0317 18.473 23.5101C19.8221 22.9884 20.737 24.8337 22.6255 25.0782C24.5141 25.3226 21.5263 27.9747 20.0335 27.2639C18.5407 26.5531 19.9636 25.8481 20.2167 26.0175C20.4698 26.1868 22.6879 26.2119 20.6903 24.9966C18.6926 23.7812 18.6023 25.1633 18.5225 26.5636C18.4428 27.9639 16.4526 27.8461 13.4639 25.4944C10.4753 23.1426 10.2293 21.0519 10.8089 20.6687C11.3886 20.2855 14.495 20.5209 18.1048 19.8541C21.7145 19.1874 18.6115 21.707 15.8906 20.7102Z",
    fill: "#DE0098"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8338 29.0538C17.0114 28.6883 20.5291 26.8952 23.9166 25.7258C27.3041 24.5563 24.3629 27.8271 19.8338 29.0538Z",
    fill: "#FF83FF"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3508 13.5381C16.9669 14.672 19.6826 16.6183 21.8532 16.8552C24.0237 17.0922 23.0461 14.2638 21.857 13.499C20.668 12.7342 18.715 13.2356 18.3508 13.5381Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8329 17.0198C12.3775 16.147 11.4751 17.93 11.6874 18.55C11.8998 19.17 13.2478 17.8141 12.8329 17.0198Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7526 12.1409C17.3693 12.469 19.6835 12.1813 21.0868 12.4681C22.4901 12.7548 20.0029 11.3222 17.7526 12.1409Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4365 28.0535C11.1214 26.8516 14.7076 30.7174 18.386 30.5983C22.0644 30.4792 23.7073 28.2638 23.7017 27.9515C23.6962 27.6392 20.9196 29.2278 18.4953 29.5013C16.071 29.7749 13.4365 28.0535 13.4365 28.0535Z",
    fill: "#75FFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2345 16.8685C24.5087 16.0909 24.5829 15.2569 24.4505 14.4431C24.4517 14.3696 27.1545 16.2262 27.2624 18.683C27.3704 21.1398 27.0945 21.5952 26.5307 21.081C25.9668 20.5668 25.2098 17.3975 24.4407 17.8561C23.6716 18.3147 24.5612 21.7473 23.4123 22.6241C22.2634 23.501 21.2886 21.535 21.5399 20.1376C21.7912 18.7402 22.3183 20.4939 22.8104 19.7487C23.3024 19.0036 22.8934 18.0262 20.1495 19.3435C17.4055 20.6607 19.6714 22.0464 20.2718 20.8164C20.8721 19.5864 21.3329 22.8394 20.992 23.0896C20.6511 23.3398 19.5089 22.6645 16.8752 21.5834C14.2415 20.5022 13.6083 20.9018 13.4085 22.0607C13.2088 23.2196 16.4641 25.2766 15.5311 25.9221C14.5981 26.5676 12.4054 24.9892 11.3465 23.1299C10.2876 21.2707 10.2097 21.1021 10.5727 20.7808C10.9357 20.4596 15.7717 20.8323 19.4466 19.3367C23.1215 17.8412 24.2345 16.8685 24.2345 16.8685Z",
    fill: "#DE0098"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2448 25.0138C11.2662 24.8993 12.2209 26.6537 12.8582 26.8245C13.4956 26.9953 13.14 25.1183 12.2448 25.0138Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.6
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4766 12.1501C18.1495 12.4748 18.6137 12.6145 18.9122 12.7868C19.2106 12.9591 19.3159 12.4857 19.0879 12.2C18.8598 11.9142 18.4766 12.1501 18.4766 12.1501Z",
    fill: "#FFB192"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_490_8519",
    x1: 23.7002,
    y1: 29.5141,
    x2: 13.8858,
    y2: 11.6543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E5DDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DABBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D3A7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D19FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#BE92C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A57FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9272A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#886B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#846898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_490_8519",
    x1: 8.21995,
    y1: 12.5423,
    x2: 17.4003,
    y2: 7.49746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9082A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9386AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9D90B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ADA3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C4BCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E1DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_490_8519",
    x1: 10.3105,
    y1: 11.7292,
    x2: 15.7296,
    y2: 8.75128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A71100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D83303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC5C11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_490_8519",
    x1: 6.64988,
    y1: 7.52938,
    x2: 15.0787,
    y2: 2.89749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A71100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D83303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC5C11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_490_8519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3659 21.8186) rotate(-28.79) scale(9.60509 9.60509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E3DDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DBD1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D8CDD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D4C5CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C7ACC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#BE99C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B98FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78BC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_490_8519",
    x1: 22.7183,
    y1: 28.0151,
    x2: 16.556,
    y2: 16.8012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC7EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D20FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E00A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_490_8519",
    x1: 11.0428,
    y1: 21.5718,
    x2: 24.0582,
    y2: 14.4195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A3FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72DCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_490_8519",
    x1: 10.8537,
    y1: 24.2133,
    x2: 16.0186,
    y2: 21.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#008DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_8519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPotionPink);
export default __webpack_public_path__ + "static/media/icon-potion-pink.d1481c5c17b40d15ae45dfd647ddef8c.svg";
export { ForwardRef as ReactComponent };